module.exports = __webpack_public_path__ + "img/tiger.661dc9c5.svg";